export const COUNTRIES = {
  'en-au': {
    country: 'Australia',
    link: 'https://au.myskylight.com/',
    currency: 'AUD',
    abv: 'AU',
    localization: 'en-au',
    numberFormat: 'en-AU',
  },
  'en-ca': {
    country: 'Canada',
    link: 'https://ca.myskylight.com/',
    currency: 'CAD',
    abv: 'CA',
    localization: 'en-ca',
    numberFormat: 'en-CA',
  },
  'en-gb': {
    country: 'United Kingdom',
    link: 'https://uk.myskylight.com/',
    currency: 'GBP',
    abv: 'GB',
    localization: 'en-gb',
    numberFormat: 'en-GB',
  },
  en: {
    country: 'United States',
    link: 'https://myskylight.com/',
    currency: 'USD',
    abv: 'US',
    localization: 'en',
    numberFormat: 'en-US',
  },
}

export const LOCALIZATION = process.env.GATSBY_I18N_DEFAULT_LANGUAGE || 'en'

export const IS_FOREIGN_COUNTRY = process.env.GATSBY_I18N_DEFAULT_LANGUAGE !== 'en'

export const IN_UK = process.env.GATSBY_I18N_DEFAULT_LANGUAGE === 'en-gb'

export const IN_AU = process.env.GATSBY_I18N_DEFAULT_LANGUAGE === 'en-au'

export const IN_CA = process.env.GATSBY_I18N_DEFAULT_LANGUAGE === 'en-ca'

export const SHOW_COOKIE_CONSENT_BANNER = IN_UK
export const ENGLISH_SPEAKING_COUNTRY = IN_UK || IN_AU || IN_CA || !IS_FOREIGN_COUNTRY

export const currencyCode = COUNTRIES[LOCALIZATION]?.currency

export const TIMEZONES = {
  'en-au': 'AEST',
  'en-ca': 'EST',
  en: 'PT',
  'en-gb': 'GMT',
}

export const RETURN_GUARANTEE_PRODUCT_HANDLE = '120-days-guarantee'
export const IS_MDAYSALE = !IS_FOREIGN_COUNTRY || IN_CA || IN_AU
export const IS_MDAYSALEBANNER = !IS_FOREIGN_COUNTRY

export const entryOptions = {
  iconOnly: 'Icon_Only',
  textOnly: 'Text_Only',
  iconAndText: 'Icon_and_Text',
}

export const iconOptions = {
  greenCheck: 'Green_Check',
  darkCheck: 'Dark_Check',
  xIcon: 'X',
  custom: 'Custom',
}

export const defaultIcons = {
  [iconOptions.greenCheck]:
    'https://cdn.builder.io/api/v1/image/assets%2Fb0fdb13eaaac4a18820508d774ca5eba%2F64c6de41bb4b4d8ba0064d8892b94e1b',
  [iconOptions.darkCheck]:
    'https://cdn.builder.io/api/v1/image/assets%2Fb0fdb13eaaac4a18820508d774ca5eba%2Fa37a9bc8903d40e492a49f38db30f271',
  [iconOptions.xIcon]:
    'https://cdn.builder.io/api/v1/image/assets%2Fb0fdb13eaaac4a18820508d774ca5eba%2Fb10ebef13a0344258f448996244aefc1',
  skylightLogo:
    'https://cdn.builder.io/api/v1/image/assets/7631c00d61004b77a9517c3d27507da8/e8629ab44e23b5aacd9b1e0d8bc2d3b2d8c82bf8?placeholderIfAbsent=true',
}

export const backgroundColorOptions = {
  lightSprout: 'Light_Sprout',
  builderCream: 'Builder_Cream',
  builderCloud: 'Builder_Cloud',
  sprout: 'Sprout',
  lightGrapefruit: 'Light_Grapefruit',
  grapefruit: 'Grapefruit',
  landingSky: 'Landing_Sky',
  lightSky: 'Light_Sky',
  builderSky: 'Builder_Sky',
  lightGemstone: 'Light_Gemstone',
  darkGemstone: 'Dark_Gemstone',
  lightLavender: 'Light_Lavender',
  deepLavender: 'Deep_Lavender',
}
